import React from "react";

const DividerLine = (props) => {
  return <div className={"divider-line " + props.className}></div>;
};

export default DividerLine;
